
import React from 'react';
import SelectedCheckMark from '@assets/images/drivethru/selectedCheck.svg';
import DefaultVehicleColor from '@assets/images/drivethru/vehicleColor.png';
import { TouchableButton } from '@components/common/Touchable/index';
import cn from 'classnames';
import style from './DriveThruInfo.module.scss';

const ColorInfo = ({
  colors,
  selectedId,
  onSelect,
  serverAppTheme,
  laneCount,
  hasLanes,
}) => {
  const containerClass = cn(
    style.colorGrid,
    hasLanes && laneCount > 1 ? style.vehicletypecolor : style.vehicletypecolor2
  );

  return (
    <div className={containerClass}>
      {colors.map(color => {
        if (color?.menuItemId == null) return null;
        const isSelected = selectedId === color.menuItemId;

        return (
          <TouchableButton
            key={color.menuItemId}
            className={cn(
              'd-flex justify-content-center align-items-center br-2 border-0 position-relative',
              isSelected && 'py-1'
            )}
            style={{
              backgroundColor: isSelected
                ? serverAppTheme?.orders_selected_category
                : 'transparent',
              border: isSelected ? '2px solid #fff' : 'none',
              width: '50px',
              height: '30px',
            }}
            onClick={() => onSelect(color.menuItemId)}
            rippleEffect
          >
            <div className={style.colorCircleWrapper}>
              <img
                src={color.imageUrl || DefaultVehicleColor}
                alt="Color"
                className={style.colorImage}
              />
              {isSelected && (
                <img
                  src={SelectedCheckMark}
                  alt="Selected"
                  style={{ position: 'absolute', width: '14px', height: '14px' }}
                />
              )}
            </div>
          </TouchableButton>
        );
      })}
    </div>
  );
};
export default ColorInfo;